import useModal from 'modules/reports/hooks/modal'
import ReportsConfirmModal from 'modules/reports/modals/Confirm'
import React, {useCallback} from 'react'

function useDialog() {
  const modal = useModal()

  const confirm = useCallback(
    async function(message: React.ReactNode) {
      return new Promise(resolve => {
        modal.open(ReportsConfirmModal, {
          message,
          onConfirm: () => resolve(true),
          onCancel: () => resolve(false),
        })
      })
    },
    [modal]
  )

  return {confirm}
}

export default useDialog
